import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { isTypeValid, isSizeValid } from '../../helpers/formHelpers';
import { renderList } from '../../helpers/arrayHelpers';
import CustomIcons from '../Icons/CustomIcons';
import ErrorMessage from './ErrorMessage';
import { Button } from '../Button';

const RenderFileNames = ({ files, removeFile, removeAllFiles, maxSize }) => {
  const ArrFiles = Array.from(files);

  const FileList = () =>
    renderList(ArrFiles, ({ item, key, index }) => {
      const large = item.size > maxSize ? 'large' : '';
      return (
        <p key={key} className={`file-name ${large}`}>
          {item.name}
          <CustomIcons onPress={() => removeFile(index)} iconName="trash-can" />
        </p>
      );
    });

  const RemoveAllButton = () => {
    if (ArrFiles.length > 0) {
      return (
        <Button classButton="no-style" onPress={removeAllFiles}>
          <p className="remove-all-button">
            Remove all &nbsp;
            <CustomIcons iconName="trash-can" />
          </p>
        </Button>
      );
    }
    return null;
  };

  return (
    <>
      <FileList />
      <RemoveAllButton />
    </>
  );
};

const InputFile = ({
  droppedFiles,
  maxSize,
  multiple,
  onChange,
  required,
  validTypes,
  validTypesMessage,
}) => {
  const [sizeMessagge, setSizeMessage] = useState('');
  const [typeMessagge, setTypeMessage] = useState('');
  const [Files, setFiles] = useState([]);
  const inputText = multiple ? 'Choose files' : 'Choose file';
  const errorsValidation = (files) => {
    setTypeMessage(
      isTypeValid(files, validTypes)
        ? ''
        : `One of the files has an invalid type, please replace it. Valid types: ${validTypesMessage}.  `
    );
    setSizeMessage(
      isSizeValid(files, maxSize)
        ? ''
        : 'The files below in red are too large, please replace them '
    );
    return isSizeValid(files, maxSize) && isTypeValid(files, validTypes);
  };

  const validateFiles = (files) => {
    const isValid = errorsValidation(files);
    setFiles(files);
    onChange(files, isValid);
  };

  const [filesArray, setFilesArray] = useState([]);

  const onFilesChange = () => {
    const filesCopy = [...Files];
    filesArray.forEach((inputFile) => {
      if (!Files.find((currentFile) => currentFile.name === inputFile.name)) {
        filesCopy.push(inputFile);
      }
    });
    validateFiles(filesCopy);
  };

  useEffect(() => {
    setFilesArray(Array.from(droppedFiles));
  }, [droppedFiles]);

  useEffect(() => {
    onFilesChange();
  }, [filesArray]);

  const handleOnChange = (e) => {
    setFilesArray(Array.from(e.target.files));
  };

  const removeFile = (index) => {
    const filesCopy = [...Files];
    filesCopy.splice(index, 1);
    validateFiles(filesCopy);
    document.querySelector('.file-input input').value = null;
  };

  const removeAllFiles = () => {
    validateFiles([]);
    document.querySelector('.file-input input').value = null;
  };

  return (
    <div className="file-wrapper">
      <label className="file-input">
        <input
          accept={validTypes}
          multiple={multiple}
          name="file-upload"
          onChange={handleOnChange}
          type="file"
          required={required}
        />
        <span className="file-span">
          <CustomIcons iconName="file-upload" />
          {inputText}
        </span>
      </label>
      <ErrorMessage error={sizeMessagge} />
      <ErrorMessage error={typeMessagge} />
      <RenderFileNames
        files={Files}
        removeFile={removeFile}
        removeAllFiles={removeAllFiles}
        maxSize={maxSize}
      />
    </div>
  );
};

InputFile.propTypes = {
  droppedFiles: PropTypes.shape({}),
  maxSize: PropTypes.number,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  validTypes: PropTypes.string,
  validTypesMessage: PropTypes.string,
};

InputFile.defaultProps = {
  droppedFiles: {},
  maxSize: 1e6,
  multiple: false,
  onChange: () => {},
  required: false,
  validTypes: '',
  validTypesMessage: '',
};

export default InputFile;
